import axios from 'axios';
import config from './config';

export default axios.create({
  baseURL: config.host,
  timeout: 10000,
});



// WEBPACK FOOTER //
// ./src/viFetchAdapter.js